import { create } from 'zustand';

interface HcoDataScopeState {
  preference: boolean;
  setPreference: (includeAllDepartments: boolean) => void;
}

const useHcoDataScopeStore = create<HcoDataScopeState>(set => ({
  preference: true,
  setPreference: preference => set({ preference }),
}));

export default useHcoDataScopeStore;
